import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../../Miscelania/RequestApi';

// Importação da tabela
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';

// Helpers de formulário
import InputMask from 'react-input-mask';
import Select from 'react-select';

class TrainingMattersTab extends Component {
  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed',        
      },
      redirect_url: false,
      training_id: null,
      lista_treinamentos: [],
      dados: [],
    };
    this.botaoDeletar = this.botaoDeletar.bind(this);
    this.adicionarTreinamento = this.adicionarTreinamento.bind(this);
    this.deletar = this.deletar.bind(this);
    this.deletarLinha = this.deletarLinha.bind(this);
  }

  handleSelectChange(name, event) {
    var change = {};
    if(event == null) {
      change[name] = null;
    } else {
      change[name] = event.value;
    }
    this.setState(change);
  }

  // LM
  componentWillReceiveProps(newProps) {
    if(Array.isArray(newProps.treinamentos) && Array.isArray(newProps.lista_treinamentos)) {
      this.setState({dados: newProps.treinamentos, lista_treinamentos: newProps.lista_treinamentos});
    }
  }

  adicionarTreinamento(event) {
    event.preventDefault();
    var datasave = {
      training_id: this.state.training_id,
      matter_id: this.props.matter_id,
    };
    var header = this.refs.request_api.header('application/json');
    this.props.handleAlert('', '', 'open');
    var self = this;
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/materia/treinamento', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        if (responseJson.status === 'success') {
          var dados_temp = self.state.dados;
          dados_temp.push(responseJson.data);
          self.setState({dados: dados_temp});
        }
        self.props.handleAlert(responseJson.message, responseJson.status, 'open');
      }).catch((error) => {
        console.error(error);
      });
    });
  }

  botaoDeletar (cell, row, enumObject, index) {
    var variavel = (
      /*<BotaoDeletar url={"/materia/treinamento/"+ cell} />*/
      <button className="btn btn-sm btn-danger" value={cell} onClick={this.deletar}>
        <i className="fa fa-fw fa-trash"></i>
      </button>
    );

    return variavel;
  }

  deletar (event) {
    var training_matter_id = event.currentTarget.value;
    var confirm = window.confirm('Tem certeza que gostaria de deletar essa treinamento?');
    if (confirm) {
      this.props.handleAlert('', '', 'open');
      var header = this.refs.request_api.header('application/json');
      var self = this;
      Promise.resolve(header).then(function(value) {
        fetch(config.get('api') + '/materia/treinamento/' + training_matter_id, { method: 'DELETE', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
          self.refs.request_api.validate(responseJson, 'alert');
          if (responseJson.status === 'success') {
            self.deletarLinha(training_matter_id);
          }
          self.props.handleAlert(responseJson.message, responseJson.status, 'open');
        }).catch((error) => {
          console.error(error);
        });
      });      
    }
  }

  deletarLinha(training_matter_id) {
    var dados = this.state.dados;
    dados.map(function(dado, index){
      if (dado.id == training_matter_id) {
        dados.splice(index, 1);
      }
    });
    this.setState({dados: dados});
  }

  render() {
    return (
<div>
  <RequestApi ref={'request_api'} />
  <form onSubmit={this.adicionarTreinamento}> 
    <div className="row">
      <div className="col-md-6">
        <div className="form-group">
          <label>Treinamentos:</label>
            <Select
              className="form-field-name"
              name="training_id"
              value={this.state.training_id}
              searchable={true}
              placeholder={'Selecionar Treinamentos'}
              onChange={this.handleSelectChange.bind(this, 'training_id')}
              options={this.state.lista_treinamentos}
            />    
        </div>
      </div>
      <div className="col-md-6">
        <button type="submit" className="btn btn-primary btn-inline btn-block"><i className="fa fa-fw fa-save"></i> Adicionar treinamento</button>
      </div>
    </div>
  </form>
  <hr/>
  <BootstrapTable data={this.state.dados} pagination={true} striped={true} hover={true} exportCSV={true} options={{exportCSVText: 'Exportar CSV', sizePerPage: 100, noDataText: 'Não há treinamentos cadastradas'}} search={true} multiColumnSearch={true}  searchPlaceholder='Procurar'>

    <TableHeaderColumn isKey={true} dataField="treinamento" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: 'Procurar'}}>Treinamento</TableHeaderColumn>

    <TableHeaderColumn dataField="id" dataAlign="center" dataFormat={this.botaoDeletar} width='80'>Ações</TableHeaderColumn>

  </BootstrapTable>
</div>
    );
  }
}

export default TrainingMattersTab;



// WEBPACK FOOTER //
// ./src/Components/Matters/Elements/TrainingMattersTab.js